import { createFileRoute, redirect } from '@tanstack/react-router'

import { LeaveReportsPage } from '@/features/leave/pages/LeaveReportsPage'
import { isAdminUser, isOrganisationAdminUser } from '@/lib/role-guards'

export const Route = createFileRoute('/_authenticated/leave-mgt/reports')({
  beforeLoad: ({ context }) => {
    if (!isAdminUser(context.auth.user) && !isOrganisationAdminUser(context.auth.user)) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: LeaveReportsPage,
})
